import React from 'react'
import { backendGetRequest } from '../../../../../../helpers/callBackend';
import { downloadPDF } from '../../../../../../helpers/downloadPDF';

const DownloadVerificationDoc = (props) => {

  const downloadVerificationDocument = () => {
    if (props.record.account.source === "UN") {
      backendGetRequest(
        "/api/bank-account/verification-document",
        { params: { bank_account_id: props.record.id } },
        "loading"
      ).then((res) => {
        const d = res?.data;
        downloadPDF(
          d,
          `verification-document-${props.record.account.bank?.name
            .toLowerCase()
            .replace(/ /g, "-")}.pdf`
        );
      })
    }
  };

  return (
    <>
      {props.record.account.source === "UN" && (
        <span style={{ color: "#1890ff" }} onClick={downloadVerificationDocument}>
          <span>Download Verification Document</span>
        </span>
      )}
    </>
  )
}

export default DownloadVerificationDoc